import CreateVideoStepDto from '@settings/models/dto/create-video-step.dto';
import UpdateVideoStepItemDto from '@settings/models/dto/update-video-step-item.dto';
import {
  createCvVideoStep,
  disableVideoStepById,
  editCvVideoStep,
  enableVideoStepById,
  updateVideoStepById,
  updateVideoStepsOrder,
} from '@settings/services/videoStepServices';

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

export const useUpdateVideoStepMutation = () => {
  const updateVideoStepMutation = useMutation<
    AxiosResponse<string>,
    unknown,
    { payload: UpdateVideoStepItemDto; id: string },
    unknown
  >(({ id, payload }) => updateVideoStepById(id, payload));

  return updateVideoStepMutation;
};

export const useUpdateVideoStepOrderMutation = () => {
  const queryClient = useQueryClient();
  const updateVideoStepOrderMutations = useMutation<
    AxiosResponse<string>,
    unknown,
    { id: string; rank: number }[],
    unknown
  >((mutationVariables) => updateVideoStepsOrder(mutationVariables), {
    onSuccess: () => {
      queryClient.invalidateQueries(['cv-video-steps']);
    },
  });

  return updateVideoStepOrderMutations;
};

export const useDisableVideoStepMutation = () => {
  const queryClient = useQueryClient();
  const disableVideoStepMutation = useMutation<
    AxiosResponse<string>,
    unknown,
    { id: string },
    unknown
  >((mutationVariables) => disableVideoStepById(mutationVariables.id), {
    onSuccess: () => {
      queryClient.invalidateQueries(['cv-video-steps']);
    },
  });

  return disableVideoStepMutation;
};

export const useEnableVideoStepMutation = () => {
  const queryClient = useQueryClient();
  const enableVideoStepMutation = useMutation<
    AxiosResponse<string>,
    unknown,
    { id: string },
    unknown
  >((mutationVariables) => enableVideoStepById(mutationVariables.id), {
    onSuccess: () => {
      queryClient.invalidateQueries(['cv-video-steps']);
    },
  });

  return enableVideoStepMutation;
};

export const useCreateCvVideoStepMutation = () => {
  const queryClient = useQueryClient();
  const createVideoStepMutation = useMutation<
    AxiosResponse<string>,
    unknown,
    { payload: CreateVideoStepDto },
    unknown
  >((mutationVariables) => createCvVideoStep(mutationVariables.payload), {
    onSuccess: () => {
      queryClient.invalidateQueries(['cv-video-steps']);
    },
  });

  return createVideoStepMutation;
};

export const useEditCvVideoStepMutation = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation<
    AxiosResponse<string>,
    unknown,
    { id: string; payload: CreateVideoStepDto },
    unknown
  >(({ id, payload }) => editCvVideoStep(id, payload), {
    onSuccess: () => {
      queryClient.invalidateQueries(['cv-video-steps']);
    },
  });

  return mutation;
};
